/* Style options and date formatter for the AI Summary banner. */

import type { SummaryStyle } from "../../../convex/aiSummary";

export { type SummaryStyle };

export interface StyleOption {
  value: SummaryStyle;
  label: string;
}

export const SUMMARY_STYLE_OPTIONS: StyleOption[] = [
  { value: "concise", label: "Concise" },
  { value: "regular", label: "Regular" },
  { value: "comprehensive", label: "Comprehensive" },
];

export const LOCALSTORAGE_KEYS = {
  collapsed: "aiSummaryCollapsed",
  style: "aiSummaryStyle",
  excludeReels: "feedkiwi-feed-breakdown-exclude-reels",
} as const;

/** Format a YYYY-MM-DD string into a readable date like "Thursday, February 13". */
export function formatSummaryDate(dateStr: string): string {
  const [year, month, day] = dateStr.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
  });
}
